import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig, sitConfigWithTraceId } from './config'
import { getFormattedDate } from './eosCreateWorkItem'
import { isStatusOK, getErrorMessage } from '../utils'

const getCreateGroupRequestBody = (data: any) => {
  return {
    applicationId: `NEW-${getFormattedDate()}`,
    ...data,
  }
}

const createGroup = (data: any, tokens: any, traceId: string) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.createGroup_camunda,
    body: getCreateGroupRequestBody(data),
    method: 'POST',
    headers: sitConfigWithTraceId(tokens, traceId).headers,
  }
  return executeRequest(request)
    .then((data) => {
      if (isStatusOK(data)) {
        return data?.data
      }
      throw { message: getErrorMessage(data?.data) }
    })
    .catch((err) => {
      throw err
    })
}

export { createGroup }
